import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent,
  Box,
  Typography
} from '@mui/material';

const DetailModal = ({ open, onClose, data, type }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleString();
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: {
          backgroundColor: '#23272f',
          color: '#fff',
          minWidth: '800px'
        }
      }}
    >
      <DialogTitle sx={{ 
        m: 0, 
        p: 2, 
        display: 'flex', 
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '2px solid #00ffe0'
      }}>
        <Typography variant="h6" component="div" sx={{ color: '#00ffe0', fontWeight: 600 }}>
          {type === 'karma' ? 'Karma' : 'Credit'}: {data?.total || 0}
        </Typography>
        <button
          onClick={onClose}
          style={{
            background: 'transparent',
            border: 'none',
            color: '#fff',
            cursor: 'pointer',
            fontSize: '20px',
            padding: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'color 0.2s'
          }}
          onMouseOver={(e) => e.target.style.color = '#00ffe0'}
          onMouseOut={(e) => e.target.style.color = '#fff'}
        >
          ✕
        </button>
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ 
            width: '100%', 
            borderCollapse: 'separate', 
            borderSpacing: 0, 
            marginTop: '20px', 
            background: '#23272f', 
            color: '#00ffe0', 
            borderRadius: 8, 
            overflow: 'hidden', 
            boxShadow: '0 2px 8px #0006' 
          }}>
            <thead>
              <tr style={{ backgroundColor: '#181c22' }}>
                <th style={{ padding: '14px', textAlign: 'left', borderBottom: '2px solid #00ffe0', color: '#00ffe0', fontWeight: 600 }}>Activity</th>
                <th style={{ padding: '14px', textAlign: 'left', borderBottom: '2px solid #00ffe0', color: '#00ffe0', fontWeight: 600 }}>Date</th>
                <th style={{ padding: '14px', textAlign: 'left', borderBottom: '2px solid #00ffe0', color: '#00ffe0', fontWeight: 600 }}>{type === 'karma' ? 'Karma' : 'Credit'}</th>
              </tr>
            </thead>
            <tbody>
              {data?.activities?.map((activity, idx) => (
                <tr key={idx}
                  style={{ 
                    borderBottom: '1px solid #00ffe0', 
                    background: idx % 2 === 0 ? '#23272f' : '#181c22',
                    transition: 'background 0.2s'
                  }}
                  onMouseOver={e => e.currentTarget.style.background = '#26313a'}
                  onMouseOut={e => e.currentTarget.style.background = idx % 2 === 0 ? '#23272f' : '#181c22'}
                >
                  <td style={{ padding: '12px', color: '#fff' }}>{activity.activity || 'N/A'}</td>
                  <td style={{ padding: '12px', color: '#fff' }}>{formatDate(activity.date)}</td>
                  <td style={{ padding: '12px', color: '#00ffe0', fontWeight: 600 }}>{activity.amount || 0}</td>
                </tr>
              ))}
              {(!data?.activities || data.activities.length === 0) && (
                <tr>
                  <td colSpan="3" style={{ padding: '20px', textAlign: 'center', color: '#fff' }}>
                    No activity data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DetailModal; 